<google-map
  height="620px"
  width="100%"
  [center]="center"
  [zoom]="zoom"
  (mapInitialized)="onMapReady($event)">
  <!-- <map-marker [position]="center"></map-marker>  -->
</google-map>
